// A row of equal-width options on a soft track, with a white thumb that slides
// under the selected one. Options are radios: the selected one is the value.
export default function SegmentedControl({
  label,
  options,
  value,
  onChange,
}) {
  const index = Math.max(
    0,
    options.findIndex((option) => option.value === value),
  );

  return (
    <div
      role="radiogroup"
      aria-label={label}
      className="segmented"
      style={{ "--segment-count": options.length, "--segment-index": index }}
    >
      <span className="segmented__thumb" aria-hidden="true" />
      {options.map((option) => (
        <button
          key={String(option.value)}
          type="button"
          role="radio"
          aria-checked={option.value === value}
          className={`segmented__option${
            option.value === value ? " segmented__option--selected" : ""
          }`}
          title={option.title}
          onClick={() => option.value !== value && onChange?.(option.value)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

// A single on/off option in the same style: the track alone when off, the
// raised thumb filling it when on.
export function SegmentedToggle({ label, pressed, onChange, title }) {
  return (
    <button
      type="button"
      aria-pressed={!!pressed}
      className={`segmented segmented--toggle${pressed ? " segmented--on" : ""}`}
      title={title}
      onClick={() => onChange?.(!pressed)}
    >
      <span className="segmented__thumb" aria-hidden="true" />
      <span className="segmented__option">{label}</span>
    </button>
  );
}
